import styled from "styled-components";

export const Border = styled.div`
  width: 25vw;
  height: 90vh;

  @media (max-width: 768px) {
    width: 100vw;
    height: 100%;
  }
`;

export const SearchBar = styled.div`
  margin: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  background: rgba(118, 118, 128, 0.12);
  @media (max-width: 768px) {
    width: auto;
  }
  input {
    width: 100%;
    outline: none;
    border: 0;
    background-color: transparent;
    font-size: 16px;
  }
`;

export const NoSearchChat = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
  }
  span {
    font-weight: 600;
    color: #000;
    font-size: 20px;
  }
`;
export const NoChat = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;

  @media (max-width: 768px) {
    padding: 10px;
    max-width: 100%;
  }
  span:nth-child(1) {
    font-weight: 600;
    color: #000;
    font-size: 20px;
  }
  span:nth-child(2) {
    text-align: center;
    color: #807f80;
    font-size: 16px;
    font-weight: 400;
  }
  button {
    padding: 10px;
    background-color: #000;
    color: #fff;
    border-radius: 20px;
    text-transform: capitalize;
    font-size: 14px;
    transition: 0.7s cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover {
      opacity: 0.9;
    }
    &:active {
      scale: 0.95;
    }
  }
`;

export const ChatFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 80vh;
  overflow-y: scroll;
  @media (max-width: 768px) {
    width: auto;
    height: 80vh;
  }
  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;
export const Chat = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px;
  margin: 5px;
  border-bottom: 1px solid rgba(118, 118, 128, 0.12);

  @media (max-width: 768px) {
    width: auto;
  }

  &:hover {
    border-radius: 10px;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    background-color: rgba(118, 118, 128, 0.12);
  }

  div:nth-child(1) {
    width: 19rem;
    align-items: center;
    display: flex;
    gap: 10px;

    img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 50%;
    }
    div {
      display: flex;
      align-items: flex-start;
      gap: 5px;
      flex-direction: column;
      height: 3rem;

      span:nth-child(1) {
        text-transform: capitalize;
        color: #000;
        font-weight: 600;
        display: inline-block;
        width: 14vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          width: 65vw;
        }
      }
      span:nth-child(2) {
        display: inline-block;
        width: 14vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          width: 60vw;
        }
      }
    }
  }
  p {
    font-size: 12px;
    display: inline-block;
    white-space: nowrap;
  }
`;
